import { useState, useEffect } from 'react';

/**
 * Hook para debounce de valores
 * Retorna el valor debounced después del delay especificado
 * @param value - El valor a debounce
 * @param delay - El delay en milisegundos (default: 300ms)
 * @returns El valor debounced
 */
export function useDebounce<T>(value: T, delay: number = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Cleanup: cancela el timer si el componente se desmonta o el valor cambia
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
